export default function AboutMe() {
  const stats = [
    { value: '£10k+', label: 'In paid media budgets managed every month' },
    { value: '5M+', label: 'Impressions delivered monthly across campaigns' },
    { value: '100%', label: 'Optimised to client objectives' },
  ];

  return (
    <section id="about" aria-label="About Charlie Peters – Meta Ads Specialist" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

          {/* Image side */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden w-full h-[520px]">
              <img
                src="https://public.readdy.ai/ai/img_res/edited_38d4ecdd667646af29194463f053b868_2e73064c.jpg"
                alt="Charlie Peters – Certified Meta Paid Ads Specialist"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
            </div>

            {/* Floating badge */}
            <a
              href="https://www.coursera.org/account/accomplishments/verify/K8XWGQ3OSR0G"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="View Charlie Peters Meta Paid Specialist certification on Coursera"
              className="absolute bottom-4 left-1/2 -translate-x-1/2 w-[calc(100%-2rem)] lg:w-auto lg:bottom-[-24px] lg:left-auto lg:right-[-24px] lg:translate-x-0 bg-white rounded-2xl shadow-xl px-6 py-4 flex items-center gap-3 hover:shadow-2xl transition-shadow cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-pink-100">
                <i className="ri-medal-line text-pink-600 text-xl"></i>
              </div>
              <div>
                <p className="text-xs text-gray-500 font-medium">Certified</p>
                <p className="text-sm font-bold text-gray-900">Meta Paid Specialist</p>
                <p className="text-xs text-pink-500 font-medium mt-0.5 flex items-center gap-1">
                  View credential <i className="ri-external-link-line text-xs"></i>
                </p>
              </div>
            </a>
          </div>

          {/* Text side */}
          <div className="flex flex-col gap-8">
            <div>
              <span className="text-xs font-semibold tracking-widest uppercase text-pink-600">About Me</span>
              <h2 className="mt-3 text-4xl font-bold text-gray-900 leading-tight">
                Hi, I'm Charlie Peters
              </h2>
              <div className="mt-1 w-12 h-1 rounded-full bg-gradient-to-r from-pink-500 to-pink-300"></div>
            </div>

            <div className="space-y-4 text-gray-600 text-[15px] leading-relaxed">
              <p>
                I'm a <strong className="text-gray-900">Meta Ads Specialist</strong> at a social publisher with over <strong className="text-gray-900">20 million followers</strong> — giving me a front-row seat to what actually moves the needle on <strong className="text-gray-900">Facebook &amp; Instagram advertising</strong>.
              </p>
              <p>
                Day-to-day I plan, launch and optimise <strong className="text-gray-900">paid social campaigns</strong> with budgets in the <strong className="text-gray-900">thousands</strong>, regularly hitting KPIs of <strong className="text-gray-900">over 1 million impressions</strong> per campaign. Whether a client needs reach, conversions or engagement, I build and tune the strategy around their exact objective.
              </p>
              <p>
                I've worked across a wide range of verticals and ad formats — from awareness-driving video to direct-response conversion campaigns — always with a data-first approach to optimisation. Now I bring that same expertise to brands and businesses looking to get serious results from their Meta ad spend.
              </p>
            </div>

            {/* Stats row */}
            <div className="grid grid-cols-3 gap-4 pt-2">
              {stats.map((stat) => (
                <div key={stat.label} className="bg-white rounded-xl px-5 py-4 border border-gray-100">
                  <p className="text-2xl font-bold text-pink-600">{stat.value}</p>
                  <p className="text-xs text-gray-500 mt-1 leading-snug">{stat.label}</p>
                </div>
              ))}
            </div>

            <div className="flex items-center gap-4 pt-2">
              <a
                href="#contact"
                className="bg-gradient-to-r from-pink-600 to-pink-700 text-white px-7 py-3 rounded-full text-sm font-semibold hover:from-pink-700 hover:to-pink-800 transition-all whitespace-nowrap"
              >
                Let's Work Together
              </a>
              <a
                href="https://www.linkedin.com/in/charliegeorgepeters/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Charlie Peters LinkedIn profile"
                className="flex items-center gap-2 text-sm font-medium text-gray-700 hover:text-pink-600 transition-colors whitespace-nowrap"
              >
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-linkedin-box-fill text-2xl"></i>
                </div>
                LinkedIn
              </a>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
